<tui-textfield
  iconStart="@tui.globe"
  tuiChevron
  tuiTextfieldSize="m"
  [tuiDropdownAlign]="'center'"
  [tuiDropdownLimitWidth]="'auto'"
  [tuiTextfieldCleaner]="false"
>
  {{ activeLanguage$ | async | uppercase }}
  <select
    class="w-0 !bg-transparent !shadow-none !outline-none"
    tuiTextfield
    [ngModel]="activeLanguage$ | async"
    (ngModelChange)="changeLocale($event)"
  ></select>

  <tui-data-list-wrapper
    *tuiTextfieldDropdown
    [itemContent]="languagePicker"
    [items]="availableLocales"
  />
</tui-textfield>

<ng-template #languagePicker let-locale>
  <div class="flex">
    <img
      class="mr-3 aspect-[4/3] h-6 rounded-md border-2 border-slate-700 object-cover"
      [alt]="locale.label"
      [src]="locale.flag | tuiFlag"
    />
    <p>{{ locale.label }}</p>
  </div>
</ng-template>
